import { createContext } from 'react';
import { WorkbenchDetailsContextType } from './types';

export const WorkbenchDetailsContext = createContext<WorkbenchDetailsContextType>({
  productName: '',
  icon: '',
  homeUrl: '',
} as unknown as WorkbenchDetailsContextType);
